<template>
    <views class="gift">
        <views class="gift-icon">
            <images :src="giftIcon"></images>
        </views>
        <views class="gift-title">中奖名单:</views>
        <views class="gift-content">
            <views>
                <van-swipe
                    vertical
                    class="swipe"
                    :autoplay="3000"
                    :touchable="false"
                    :show-indicators="false">
                    <van-swipe-item
                        v-for="(item, index) in list"
                        :key="index"
                        class="swipe-item">
                        恭喜{{ item.member_name }}获得{{ item.grade }}
<!--     TODO 1230:1                    -->
<!--                        <views v-if="item.gift_amount > 0" class="swipe-item-amount">{{ item.gift_amount }}元</views>-->
                        {{ item.gift_name }}
                    </van-swipe-item>
                </van-swipe>
            </views>
        </views>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            giftIcon: require('@/assets/images/sy_xzpcjan@3x.png')
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
